import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map,switchMap, withLatestFrom } from "rxjs/operators";

import { MpAdminService } from "../../../services/api/mp-admin.service";
import { MpAdminActions } from "../../actions/mp-admin.actions";
import { FailState } from "../../models/fail-state";
import { ConsumerFundsState } from "../../models/mp-admin/consumer-funds-state";
import { AppState } from "../../reducers";
import { MpAdminSelectors } from "../../selectors/mp-admin.selectors";

@Injectable()
export class AdminConsumerFundsGetEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(MpAdminActions.consumerFunds.get),
			withLatestFrom(this.store.select(MpAdminSelectors.consumerFunds)),
			switchMap(([action, state]) =>
				this.canUseStoreValue(action, state)
					? of(MpAdminActions.consumerFunds.getSuccess(state))
					: of(MpAdminActions.consumerFunds.getApi())
			)
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(MpAdminActions.consumerFunds.getApi),
			withLatestFrom(this.store.select(MpAdminSelectors.consumerFunds)),
			switchMap(() =>
				this.adminService.consumerFunds().pipe(
					map((funds) =>
						MpAdminActions.consumerFunds.getSuccess({ funds, loading: false })
					),
					catchError((error) =>
						of(MpAdminActions.consumerFunds.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private store: Store<AppState>,
		private actions: Actions,
		private adminService: MpAdminService
	) {}

	private canUseStoreValue(action, state: ConsumerFundsState): boolean {
		return !_.has(state, "error") && !state.loading;
	}
}
